import { NavLink } from 'react-router-dom';

import type { SiteContent } from '../../content/types';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Container } from '../layout/container';
import { SectionHeading } from './section-heading';
import { ServiceIcon } from './service-icon';

interface ServicesGridProps {
  content: SiteContent;
  compact?: boolean;
}

export function ServicesGrid({ content, compact = false }: ServicesGridProps): JSX.Element {
  const items = compact ? content.servicesSection.services.slice(0, 6) : content.servicesSection.services;
  const servicesLabel = content.navigation.primary.find((item) => item.href === '/leistungen')?.label ?? content.servicesSection.headline;

  return (
    <section className="py-12 sm:py-16">
      <Container className="space-y-8">
        <SectionHeading title={content.servicesSection.headline} description={content.servicesSection.intro} />
        <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          {items.map((service) => (
            <Card key={service.slug} className="h-full bg-white">
              <CardHeader className="space-y-3 pb-3">
                <div className="w-fit rounded-xl bg-[color:var(--color-primary-soft)] p-2 text-[color:var(--color-primary)]">
                  <ServiceIcon name={service.icon} className="h-5 w-5" />
                </div>
                <CardTitle className="text-base">{service.name}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3">
                <CardDescription>{service.shortText}</CardDescription>
                {compact ? null : <p className="text-sm text-[color:var(--color-muted)]">{service.detailText}</p>}
              </CardContent>
            </Card>
          ))}
        </div>
        {compact ? (
          <Button asChild variant="outline">
            <NavLink to="/leistungen">{servicesLabel}</NavLink>
          </Button>
        ) : null}
      </Container>
    </section>
  );
}
